import { Component } from 'react';
import styled from 'styled-components';

import { radius, fontSize } from '../../../../../common/css/setting/variable';
import { pcVisitedLink } from '../../../../../common/css/setting/mixin';

interface IProps {
  grade: string;
  date: string;
  raceNum: string;
  url: string;
  raceTitle: string;
  status: string;
  dataClParams: string;
}

const HorseRaceContainer = styled.div`
  display: flex;
  align-items: center;

  & + & {
    margin-top: 8px;
  }
`;

const HorseRaceContainerItem = styled.div`
  & + & {
    margin-left: 8px;
  }
`;

const HorseRaceTitle = styled.span`
  display: block;
  width: 70px;
  padding: 3px 0;
  font-size: ${fontSize.px14};
  font-weight: bold;
  color: ${props => props.theme.news.palette.text_white_common};
  text-align: center;
  background: #555;
  border-radius: ${radius.middleLow_common};
`;

const HorseRaceSubText = styled.p`
  font-size: ${fontSize.px12};
`;

const HorseRaceTitleLink = styled.a`
  ${pcVisitedLink}
  font-size: ${fontSize.px16};
`;

export default class HorseRacingRace extends Component<IProps> {
  /**
   *
   */
  public render() {
    // グレードが存在しない重賞が一部存在する。その場合は「重賞」と表示する
    const grade = this.props.grade || '重賞';

    return (
      <HorseRaceContainer>
        <HorseRaceContainerItem>
          <HorseRaceTitle>{grade}</HorseRaceTitle>
        </HorseRaceContainerItem>
        <HorseRaceContainerItem>
          <HorseRaceSubText>{`${this.props.date} ${this.props.raceNum}`}</HorseRaceSubText>
          <HorseRaceTitleLink href={this.props.url} data-cl-params={this.props.dataClParams}>
            {this.props.raceTitle}【{this.props.status}】
          </HorseRaceTitleLink>
        </HorseRaceContainerItem>
      </HorseRaceContainer>
    );
  }
}
